import { Component } from '@angular/core';
import { DeleteBase } from '../../../_classes/delete-base.class';
import ISite from '../../../_interfaces/ISite';
import { SessionService } from '../../../_services/session/session.service';
import { ConfirmationService, MessageService } from 'primeng/api';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { CalendarService } from '../../../_services/calendars/calendar.service';
import { Observable } from 'rxjs';
import { ButtonModule } from 'primeng/button';
import ICalendar from '../../../_interfaces/ICalendar';
import { EResources } from '../../../_resources/EResources';

@Component({
  selector: 'app-delete-button-calendar',
  imports: [ButtonModule, TranslatePipe],
  templateUrl: './delete-button-calendar.component.html',
  styleUrl: './delete-button-calendar.component.scss',
})
export class DeleteButtonCalendarComponent extends DeleteBase<ICalendar> {
  constructor(
    public session: SessionService,
    public confirm: ConfirmationService,
    public messageService: MessageService,
    public translate: TranslateService,
    public calendarService: CalendarService
  ) {
    super(session, confirm, messageService, translate);
  }

  delete(): Observable<any> {
    return this.calendarService.delete(
      this.customers_id,
      this.payload.sites_id,
      this.payload.id
    );
  }

  getResourceName(): string {
    return EResources.CALENDARS;
  }
}
